import { createAction, props } from '@ngrx/store';
import { CompanyDeactivationDTO } from '@iota/inh-core-v1-management-client';

export enum BusinessPartnerType {
    CUSTOMER = 'customer',
    SOLUTION_PARTNER = 'solution-partner',
    CENTRAL_REGULATOR = 'central-regulator'
}

export enum CompanyDeactivationActionTypes {
    CreateDeactivation = '[Company Deactivation] Create Deactivation',
    CreateDeactivationSuccess = '[Company Deactivation] Create Deactivation Success',
    CreateDeactivationFailure = '[Company Deactivation] Create Deactivation Failure',

    UpdateDeactivation = '[Company Deactivation] Update Deactivation',
    UpdateDeactivationSuccess = '[Company Deactivation] Update Deactivation Success',
    UpdateDeactivationFailure = '[Company Deactivation] Update Deactivation Failure',

    CancelDeactivation = '[Company Deactivation] Cancel Deactivation',
    CancelDeactivationSuccess = '[Company Deactivation] Cancel Deactivation Success',
    CancelDeactivationFailure = '[Company Deactivation] Cancel Deactivation Failure',

    RevertDeactivation = '[Company Deactivation] Revert Deactivation',
    RevertDeactivationSuccess = '[Company Deactivation] Revert Deactivation Success',
    RevertDeactivationFailure = '[Company Deactivation] Revert Deactivation Failure'
}

export const CreateDeactivation = createAction(
    CompanyDeactivationActionTypes.CreateDeactivation,
    props<{ companyId: string; deactivationDate: string }>()
);

export const CreateDeactivationSuccess = createAction(
    CompanyDeactivationActionTypes.CreateDeactivationSuccess,
    props<{ deactivation: CompanyDeactivationDTO }>()
);

export const CreateDeactivationFailure = createAction(CompanyDeactivationActionTypes.CreateDeactivationFailure, props<{ error: string }>());

export const UpdateDeactivation = createAction(
    CompanyDeactivationActionTypes.UpdateDeactivation,
    props<{ companyId: string; deactivationDate: string }>()
);

export const UpdateDeactivationSuccess = createAction(
    CompanyDeactivationActionTypes.UpdateDeactivationSuccess,
    props<{ deactivation: CompanyDeactivationDTO }>()
);

export const UpdateDeactivationFailure = createAction(CompanyDeactivationActionTypes.UpdateDeactivationFailure, props<{ error: string }>());

export const CancelDeactivation = createAction(CompanyDeactivationActionTypes.CancelDeactivation, props<{ companyId: string }>());

export const CancelDeactivationSuccess = createAction(
    CompanyDeactivationActionTypes.CancelDeactivationSuccess,
    props<{ companyId: string }>()
);

export const CancelDeactivationFailure = createAction(CompanyDeactivationActionTypes.CancelDeactivationFailure, props<{ error: string }>());

export const RevertDeactivation = createAction(CompanyDeactivationActionTypes.RevertDeactivation, props<{ companyId: string }>());

export const RevertDeactivationSuccess = createAction(
    CompanyDeactivationActionTypes.RevertDeactivationSuccess,
    props<{ companyId: string }>()
);

export const RevertDeactivationFailure = createAction(CompanyDeactivationActionTypes.RevertDeactivationFailure, props<{ error: string }>());
